import React from "react";
import { Navigate } from "react-router-dom";
import { useStore } from "@/store";
import DashboardPage from "@/features/dashboard/pages/DashboardPage";

/**
 * /dashboard kök path'i: Admin ise admin dashboard, client ise client dashboard'a yönlendirir.
 * Böylece client ve admin dashboard iki ayrı sayfa olur.
 */
const DashboardHome: React.FC = () => {
  const isStaff = useStore((state) => state.isStaff);

  if (isStaff) {
    return <DashboardPage />;
  }

  return <Navigate to="/dashboard/client-dashboard" replace />;
};

export default DashboardHome;
